
import fsm from 'svelte-fsm';
import { ConnectMapApp } from "./app";
import { type POI } from './poi';
import { get } from 'svelte/store';

export  function createFSM (app: ConnectMapApp<any>) {

  function selectPOI (poi: POI) {
    app.selectPOI(poi);
    return 'detail_view';
  }

  const initial_state = app.config.init_in_fullscreen ? 'map_view' : 'embedded_view';

  return fsm(initial_state, {

    embedded_view: {
      toggle: 'map_view',
    },

    map_view: {
      showListing: 'list_view',
      selectPOI,
      showInfo: 'info_view',
      exit: 'embedded_view',
    },

    list_view: {
      selectPOI,
      clearSearch() {
        app.search_term.set('');
        return 'list_view';
      },
      back: 'map_view',
      exit: 'embedded_view',
    },

    detail_view: {
      back: 'list_view',
      route: 'route_setup_view',
      showLocation: 'map_view',
      selectPOI,
      clearSearch() {
        app.search_term.set('');
        return 'map_view';
      },
      exit: 'embedded_view',
    },

    route_setup_view: {
      _enter() {
        app.updateSelectFor();
      },
      back: 'detail_view',
      clearSetup() {
        app.clearRouteSetup();
        return 'list_view';
      },
      flip () {
        const src = get(app.src_poi);
        const dst = get(app.dst_poi);
        app.src_poi.set(dst);
        app.dst_poi.set(src);
        app.updateSelectFor();
        return 'route_setup_view';
      },
      showRoute: 'navigation_view',
      showListing: 'list_view',
      showMap: 'map_view',
      selectPOI (poi: POI) {
        app.selectPOI(poi);
      },
      exit () {
        app.clearRouteSetup();
        return 'embedded_view';
      },
    },

    navigation_view: {
      _exit(arg) {
        app.clearRouting();
        arg.to != 'route_setup_view' && app.clearRouteSetup();
      },
      back: 'route_setup_view',
      clear: 'map_view',
      exit:'embedded_view',
    },

    info_view: { 
      back: 'map_view',
      exit: 'embedded_view',
    },
  });
}